<div class="grid m-0 p-0">
  <div class="col-12 m-0 p-0">
    <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
  </div>

  <ng-container card-body>
    <div *ngIf="(isLoading$ | async)" class=" w-full flex align-items-center justify-content-center">
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
  </ng-container>
  <div *ngIf="!(isLoading$ | async)" class="col-12 m-0 p-0 mt-4">
    <div class="h-5rem shadow-white-box flex align-items-center pl-4">
      <span class="orange-text pl-5"> Cálculo repasse profissionais</span>
      <img class="pl-1" src="assets\icons\akar-icons_info-fill.svg" alt="alerta-campo-vazio"
        [pTooltip]="tooltipCalcRepasse" />

      <ng-template #tooltipCalcRepasse>
        <div class="flex align-items-start justify-content-center flex-column">
           
          <span>A calculadora de repasses profissionais, serve para empresas que repassam a % devida aos profissionais nos valores em dinheiro. </span>
          <span>Logo o sistema irá realizar cálculo automático para facilitar vida da secretária, informando quanto cada profissional deveria </span>
          <span>receber em dinheiro, conforme os atendimentos recebidos em dinheiro pela clínica ou salão.</span>
        </div>
      </ng-template>
    </div>

    <div class="col-12 my-0 p-4">
      <div class="flex px-5">
        <div [formGroup]="repasseForm">
          <p-inputSwitch formControlName="calculatedPayout" (onChange)="saveChange()"></p-inputSwitch>
        </div>
        <div class="ml-3">
          <span class="normal-text">Calcular repasse</span>
        </div>
      </div>
    </div>
  </div>
</div>